import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";
import KaliteGecmeyenCell from "../components/KaliteGecmeyenCell";

const DURUM_BADGE = {
  "Bekliyor": "bg-zinc-100 text-zinc-600",
  "Üretimde": "bg-sky-100 text-sky-700",
  "Tamamlandı": "bg-green-100 text-green-700",
};

const PLAN_DURUM_BADGE = {
  "Planda": "bg-amber-100 text-amber-700",
  "Tamamlandı": "bg-green-100 text-green-700",
  "Üretimde": "bg-sky-100 text-sky-700",
  "Bekliyor": "bg-red-100 text-red-700",
};

export default function Orders() {
  const columns = [
    { key: "siparis_tarihi", label: "Sipariş Tarihi" },
    { key: "termin_tarihi", label: "Termin" },
    { key: "musteri", label: "Müşteri" },
    { key: "satis_noktasi", label: "Satış Noktası", render: (r) => <span className="text-zinc-600">{r.satis_noktasi || "—"}</span> },
    { key: "satis_musterisi", label: "Satış Müşterisi", render: (r) => {
        const isHoreca = (r.satis_noktasi || "").toLowerCase().includes("horeca");
        if (!isHoreca) return <span className="text-zinc-300">—</span>;
        return <span className="text-zinc-700 font-medium">{r.satis_musterisi || "—"}</span>;
      } },
    { key: "urun_kodu", label: "Ürün Kodu", mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "renk", label: "Renk" },
    { key: "siparis_adeti", label: "Sipariş", num: true },
    { key: "uretimden_yapilan", label: "Üretimden Yapılan", num: true, render: (r) => <span className="text-green-700 font-semibold">{r.uretimden_yapilan ?? 0}</span> },
    {
      key: "uretime_gore_kalan", label: "Üretime Göre Kalan", num: true,
      value: (r) => r.uretime_gore_kalan ?? r.siparis_adeti ?? 0,
      render: (r) => {
        const v = Number(r.uretime_gore_kalan ?? r.siparis_adeti) || 0;
        const cls = v > 0 ? "text-red-600" : "text-green-700";
        return <span className={`font-bold ${cls}`}>{v.toLocaleString("tr-TR")}</span>;
      },
    },
    { key: "kalite_raporu", label: "Kalite Raporu (1.Kalite)", num: true, render: (r) => <span className="text-sky-700 font-semibold">{r.kalite_raporu ?? 0}</span> },
    { key: "kalan", label: "Kaliteye Göre Kalan", num: true, render: (r) => <span className={`font-semibold ${(r.kalan ?? 0) > 0 ? "text-red-600" : "text-green-700"}`}>{r.kalan ?? r.siparis_adeti ?? 0}</span> },
    { key: "kalite_takibi", label: "Kalite Takibi (Toplam)", num: true, render: (r) => <span className="text-indigo-700 font-semibold">{r.kalite_takibi ?? 0}</span> },
    {
      key: "fark_uretim_kalite", label: "Fark (Üretim − Kalite)", num: true,
      value: (r) => r.fark_uretim_kalite ?? 0,
      render: (r) => {
        const v = Number(r.fark_uretim_kalite) || 0;
        const cls = v > 0 ? "text-amber-700" : v < 0 ? "text-red-600" : "text-zinc-500";
        return <span className={`font-bold ${cls}`}>{v.toLocaleString("tr-TR")}</span>;
      },
    },
    {
      key: "kaliteden_gecmeyen", label: "Kaliteden Geçmeyen Ürünler", num: true,
      value: (r) => r.kaliteden_gecmeyen ?? 0,
      render: (r) => <KaliteGecmeyenCell row={r} />,
    },
    {
      key: "biskuvi_stok", label: "Bisküvi Stok", num: true,
      value: (r) => r.biskuvi_stok ?? 0,
      render: (r) => <span data-testid={`biskuvi-stok-${r.id}`} className={`font-semibold ${(r.biskuvi_stok ?? 0) < 0 ? "text-red-600" : "text-sky-700"}`}>{(r.biskuvi_stok ?? 0).toLocaleString("tr-TR")}</span>,
    },
    {
      key: "guncel_siparis_adeti", label: "Güncel Sipariş Adeti", num: true,
      value: (r) => r.guncel_siparis_adeti ?? 0,
      render: (r) => <span data-testid={`guncel-siparis-${r.id}`} className="font-semibold text-amber-700">{(r.guncel_siparis_adeti ?? 0).toLocaleString("tr-TR")}</span>,
    },
    {
      key: "kalan_biskuvi_stok", label: "Kalan Bisküvi Stok ve Şekillenecek Ürün", num: true,
      value: (r) => r.kalan_biskuvi_stok ?? 0,
      render: (r) => <span data-testid={`kalan-biskuvi-stok-${r.id}`} className={`font-bold ${(r.kalan_biskuvi_stok ?? 0) < 0 ? "text-red-600" : "text-green-700"}`}>{(r.kalan_biskuvi_stok ?? 0).toLocaleString("tr-TR")}</span>,
    },
    {
      key: "durum", label: "Durum",
      value: (r) => r.durum_hesap || r.durum || "Bekliyor",
      render: (r) => {
        const d = r.durum_hesap || r.durum || "Bekliyor";
        return <span className={`px-2 py-0.5 rounded-sm text-xs font-semibold ${DURUM_BADGE[d] || "bg-zinc-100 text-zinc-600"}`}>{d}</span>;
      },
    },
    {
      key: "plan_durum", label: "Plan Durumu",
      value: (r) => `${r.plan_durum || "Bekliyor"}${Number(r.plan_adet) > 0 ? " (" + r.plan_adet + ")" : ""}`,
      render: (r) => {
        const d = r.plan_durum || "Bekliyor";
        const pa = Number(r.plan_adet) || 0;
        return (
          <div className="flex items-center gap-2">
            <span className={`px-2 py-0.5 rounded-sm text-xs font-semibold ${PLAN_DURUM_BADGE[d] || "bg-zinc-100 text-zinc-600"}`} data-testid={`plan-durum-badge-${r.id}`}>{d}</span>
            {d === "Planda" && pa > 0 && <span className="text-xs font-bold text-amber-700">{pa.toLocaleString("tr-TR")}</span>}
          </div>
        );
      },
    },
  ];
  const fields = [
    { key: "siparis_tarihi", label: "Sipariş Tarihi", type: "date", required: true },
    { key: "termin_tarihi", label: "Termin Tarihi", type: "date" },
    { key: "musteri", label: "Müşteri", type: "text", required: true },
    { key: "urun_kodu", label: "Ürün Kodu", type: "product", required: true, span: 2, fills: { kalip_kodu: "kalip_kodu", renk: "renk" } },
    { key: "kalip_kodu", label: "Kalıp Kodu (otomatik)", type: "text", readOnly: true, mono: true },
    { key: "renk", label: "Renk (otomatik)", type: "text", readOnly: true },
    { key: "satis_musterisi", label: "Satış Müşterisi (yalnız Horeca)", type: "select", options: ["İhracat", "İç Piyasa"], span: 2 },
    { key: "siparis_adeti", label: "Sipariş Adedi", type: "number", required: true },
    { key: "durum", label: "Durum", type: "select", options: ["Bekliyor", "Üretimde", "Tamamlandı"], default: "Bekliyor" },
    { key: "notlar", label: "Notlar", type: "textarea", span: 2 },
  ];
  return (
    <>
      <PageHeader title="Gelen Siparişler" subtitle="Siparişler ve üretime göre kalan adet otomatik hesaplanır" />
      <CrudTable endpoint="/entity/orders" listEndpoint="/orders/with-progress" columns={columns} fields={fields}
        titleSingular="Sipariş" printTitle="Gelen Siparişler" dateField="siparis_tarihi" exportKind="orders"
        bulkEditFields={["termin_tarihi", "durum", "siparis_adeti", "satis_musterisi", "notlar"]}
        toggleFilter={{ label: "Stok Yetersiz", test: (r) => (Number(r.kalan_biskuvi_stok) || 0) < 0 }}
        warnEmptyKeys={["kalip_kodu", "renk"]}
        warnEmptyMessage="Bazı siparişlerde Kalıp Kodu / Renk otomatik gelmedi — ürün Malzemeler'de tanımlı değil." />
    </>
  );
}
